import React from 'react';
import PropTypes from 'prop-types';
import turnstileConfig from '../../turnstile-config';

const { scriptUrl: TURNSTILE_SCRIPT_URL, scriptSelector: TURNSTILE_SCRIPT_SELECTOR } = turnstileConfig;

const Turnstile = ({ siteKey, onSuccess, onExpire, onError, className }) => {
  const containerRef = React.useRef(null);
  const widgetIdRef = React.useRef(null);

  React.useEffect(() => {
    function renderWidget() {
      if (containerRef.current && window.turnstile && widgetIdRef.current == null) {
        widgetIdRef.current = window.turnstile.render(containerRef.current, {
          sitekey: siteKey,
          size: 'flexible',
          callback: onSuccess,
          'expired-callback': onExpire,
          'error-callback': onError,
        });
      }
    }

    if (!window.turnstile) {
      let script = document.querySelector(TURNSTILE_SCRIPT_SELECTOR);
      if (!script) {
        script = document.createElement('script');
        script.src = TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
      script.addEventListener('load', renderWidget);
    } else {
      renderWidget();
    }

    return () => {
      const script = document.querySelector(TURNSTILE_SCRIPT_SELECTOR);
      if (script) {
        script.removeEventListener('load', renderWidget);
      }
      if (widgetIdRef.current != null && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
        widgetIdRef.current = null;
      }
    };
  }, []);

  return <div ref={containerRef} className={className} />;
};

Turnstile.defaultProps = {
  onExpire: () => {},
  onError: () => {},
  className: null,
};

Turnstile.propTypes = {
  siteKey: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onExpire: PropTypes.func,
  onError: PropTypes.func,
  className: PropTypes.string,
};

export default Turnstile;
